import { render, staticRenderFns } from "./TedTalkLink.vue?vue&type=template&id=4335cc96&"
import script from "./TedTalkLink.vue?vue&type=script&lang=js&"
export * from "./TedTalkLink.vue?vue&type=script&lang=js&"
import style0 from "./TedTalkLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports